<template>
  <header class="mc-rec-ord-header">
    <button
      type="button"
      class="mc-rec-ord-header__close"
      aria-label="Fechar modal"
      @click="$emit('close')"
    >
      <span class="mc-rec-ord-header__close-icon" aria-hidden="true">×</span>
      <span class="mc-rec-ord-header__close-text">Fechar</span>
    </button>
    <div class="mc-rec-ord-header__kicker">ManyConvert · Recomendações WhatsApp</div>
    <h2 class="mc-rec-ord-header__title">
      Pedido #{{ orderId }}
    </h2>
    <p class="mc-rec-ord-header__subtitle">
      {{ subtitleLine }}
    </p>
  </header>
</template>

<script>
export default {
  name: 'RecommendationOrderHeader',
  props: {
    orderId: { type: String, default: '—' },
    subtitleLine: { type: String, default: '' },
  },
}
</script>
